require('./creditModifyAssociatedAccountSuccessStep.scss');

// @ vendors
const React = require('react');
const { withRouter } = require('react-router-dom');
const PropTypes = require('prop-types');
// @ commons
const { formatText } = require('core/i18n').i18n;
const CustomMessageBox = require('components/contactCenter/customMessageBox/customMessageBox');

class CreditModifyAssociatedAccountSuccessStep extends React.Component {
    constructor(props) {
        super(props);
        this.goBackHandler = this.goBackHandler.bind(this);
    }

    goBackHandler() {
        this.props.history.push('/myprofile/cards');
    }

    render() {

        const title = formatText('accountModifySuccessStep-title');
        const subTitle = formatText('accountModifySuccessStep-subTitle');
        const goBackButtonLabel = formatText('cardPaymentPurchaseDeferralSuccess-goBackButton').toUpperCase();
        return (
            <article className="card-activator-success">
                <CustomMessageBox
                    icon="icon-success"
                    title={title}
                    subtitle={subTitle}
                    textLink={goBackButtonLabel}
                    goBackHandler={this.goBackHandler}
                />
            </article>
        );
    }
}

CreditModifyAssociatedAccountSuccessStep.propTypes = {
    history: PropTypes.object.isRequired,
}

module.exports = withRouter(CreditModifyAssociatedAccountSuccessStep);
